export default "__VITE_ASSET__BYZLVoeg__"